import * as stylex from "@stylexjs/stylex";
import { colors, fonts } from "@softmax/design-system/tokens.stylex";
import { CopyReplayText } from "./copy-replay-text";

const styles = stylex.create({
  command: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: colors.border,
    borderRadius: 4,
    paddingBlock: 8,
    paddingInline: 12,
    backgroundColor: colors.surface,
  },
  code: {
    minWidth: 0,
    flex: 1,
    overflowX: "auto",
    color: colors.foreground,
    fontFamily: fonts.mono,
    fontSize: 12,
    whiteSpace: "nowrap",
  },
});

export function ReplayCommand({ command }: Readonly<{ command: string }>) {
  return (
    <div {...stylex.props(styles.command)}>
      <code {...stylex.props(styles.code)}>{command}</code>
      <CopyReplayText key={command} text={command} label="Copy" />
    </div>
  );
}
